import styled from "styled-components";

export const ProfileContainer = styled.div`
margin:20px;
border:1px solid #000;
width: 300px;

border-radius: 15px;
padding: 15px;
background-color: #fff;
position: relative;
height: 240px;
`
export const Avatar = styled.img`
display: block;
margin-left: auto;
margin-right: auto;
height: 90px;
width: 90px;
border-radius: 50%;
`

export const UserName = styled.p`
text-align: center;
font-size:20px;
margin:10px 0 5px 0;
`
export const UserTag = styled.p`
text-align: center;
font-size:15px;
margin:0;
color: rgb(95, 95, 95);
`
export const UserLocation = styled.p`
text-align: center;
font-size:15px;
margin:10px 0 5px 0;
`